module.exports = __webpack_public_path__ + "img/28_bohle.f3f2526a.jpeg";